import ee from 'event-emitter';

const MyClass = function () {};
ee(MyClass.prototype);
const emitter = new MyClass()

export const useEventEmitter = () => {
  return emitter;
}